'use client';

import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';

interface FormProps<T extends FieldValues> {
    form: UseFormReturn<T>;
    onSubmit: (values: T) => void;
    children: React.ReactNode;
}

export default function Form<T extends FieldValues>({ form, onSubmit, children, ...props }: FormProps<T>) {
    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} {...props}>
                {children}
            </form>
        </FormProvider>
    );
}

